"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allTypes = exports.PERSONAL_SAVINGS_ACCOUNT = exports.PERSONAL_CHECKING_ACCOUNT = exports.KABBAGE_PAYMENTS = exports.KABBAGE_LOC = exports.KABBAGE_INSIGHTS = exports.KABBAGE_BCA = exports.KABBAGE_ACCOUNT = exports.INVESTMENT_ACCOUNT = exports.CRYPTO_ACCOUNT = exports.CROSS_BORDER_PAYMENTS = exports.CARD_PRODUCT = exports.CARD_ACCOUNT = exports.BUSINESS_CHECKING_ACCOUNT = void 0;
// artificial type to separate member from one-data
const CARD_PRODUCT = 'CARD_PRODUCT';

// one-data function product types
// https://explorer.aexp.com/functions/ReadIdentityProductsRegistryMapping.sor.v1
exports.CARD_PRODUCT = CARD_PRODUCT;
const CARD_ACCOUNT = 'AEXP_CARD_ACCOUNT';
exports.CARD_ACCOUNT = CARD_ACCOUNT;
const PERSONAL_SAVINGS_ACCOUNT = 'AEXP_PERSONAL_SAVING_ACCOUNT';
exports.PERSONAL_SAVINGS_ACCOUNT = PERSONAL_SAVINGS_ACCOUNT;
const PERSONAL_CHECKING_ACCOUNT = 'AEXP_PERSONAL_CHECKING_ACCOUNT';
exports.PERSONAL_CHECKING_ACCOUNT = PERSONAL_CHECKING_ACCOUNT;
const BUSINESS_CHECKING_ACCOUNT = 'AEXP_BUSINESS_CHECKING_ACCOUNT';
exports.BUSINESS_CHECKING_ACCOUNT = BUSINESS_CHECKING_ACCOUNT;
const CROSS_BORDER_PAYMENTS = 'AEXP_CROSS_BORDER_PAYMENTS';
exports.CROSS_BORDER_PAYMENTS = CROSS_BORDER_PAYMENTS;
const KABBAGE_ACCOUNT = 'AEXP_KABBAGE_ACCOUNT';
exports.KABBAGE_ACCOUNT = KABBAGE_ACCOUNT;
const KABBAGE_LOC = 'AEXP_KABBAGE_LOC';
exports.KABBAGE_LOC = KABBAGE_LOC;
const KABBAGE_BCA = 'AEXP_KABBAGE_BCA';
exports.KABBAGE_BCA = KABBAGE_BCA;
const KABBAGE_PAYMENTS = 'AEXP_KABBAGE_PAYMENTS';
exports.KABBAGE_PAYMENTS = KABBAGE_PAYMENTS;
const KABBAGE_INSIGHTS = 'AEXP_KABBAGE_INSIGHTS';
exports.KABBAGE_INSIGHTS = KABBAGE_INSIGHTS;
const INVESTMENT_ACCOUNT = 'AEXP_INVEST_WEALTH_ACCOUNT';
exports.INVESTMENT_ACCOUNT = INVESTMENT_ACCOUNT;
const CRYPTO_ACCOUNT = 'AEXP_CRYPTO_ACCOUNT';

// define default order as node no longer respects export order
exports.CRYPTO_ACCOUNT = CRYPTO_ACCOUNT;
const allTypes = [CARD_PRODUCT, CARD_ACCOUNT, PERSONAL_SAVINGS_ACCOUNT, PERSONAL_CHECKING_ACCOUNT, BUSINESS_CHECKING_ACCOUNT, CROSS_BORDER_PAYMENTS, KABBAGE_ACCOUNT, KABBAGE_LOC, KABBAGE_BCA, KABBAGE_PAYMENTS, KABBAGE_INSIGHTS, INVESTMENT_ACCOUNT, CRYPTO_ACCOUNT];
exports.allTypes = allTypes;